import { render, staticRenderFns } from "./instance.vue?vue&type=template&id=570f07c1&scoped=true&"
import script from "./instance.vue?vue&type=script&lang=js&"
export * from "./instance.vue?vue&type=script&lang=js&"
import style0 from "./instance.vue?vue&type=style&index=0&id=570f07c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570f07c1",
  null
  
)

export default component.exports